import { Record as record } from 'immutable';
import Joi from 'joi';
import _ from 'lodash';

import ValidationMixin from '../ValidationMixin';
import validators from '../../validation';

const defaults = {
    email: null,
    firstNames: null,
    surname: null,
    title: null,
    confirmemail: null,
    password: null,
    newPassword: null,
    telephoneNumber: null,
    changeEmail: false,
    changePassword: false,
    changePhone: false,
    changeName: false
};

class CustomerUserChange extends record(defaults) {

    getSchema () {
        return {
            email: Joi.alternatives().when('changeEmail', {
                is: true,
                then: validators.email(),
                otherwise: Joi.any()
            }),
            confirmemail: Joi.alternatives().when('changeEmail', {
                is: true,
                then: validators.confirmEmail(),
                otherwise: Joi.any()
            }),

            password: Joi.alternatives().when('changePassword', {
                is: true,
                then: validators.passwordEntry(),
                otherwise: Joi.any()
            }),

            newPassword: Joi.alternatives().when('changePassword', {
                is: true,
                then: validators.passwordCreate().required(),
                otherwise: Joi.any()
            }),

            telephoneNumber: Joi.alternatives().when('changePhone', {
                is: true,
                then: validators.phone().allow('', null),
                otherwise: Joi.any()
            }),

            firstNames: Joi.alternatives().when('changeName', {
                is: true,
                then: validators.name(2, 50),
                otherwise: Joi.any()
            }),

            surname: Joi.alternatives().when('changeName', {
                is: true,
                then: validators.name(2, 50),
                otherwise: Joi.any()
            }),

            title: Joi.alternatives().when('changeName', {
                is: true,
                then: validators.title(),
                otherwise: Joi.any()
            })
        };
    }

    get changes () {
        return _.omitBy({
            email: this.changeEmail ? this.email : null,
            password: this.changePassword ? this.newPassword : null,
            telephoneNumber: this.changePhone ? this.telephoneNumber : null,
            firstNames: this.changeName ? this.firstNames : null,
            surname: this.changeName ? this.surname : null,
            title: this.changeName ? this.title : null
        }, _.isNull);
    }

    hasChanges () {
        return this.changeEmail || this.changePassword || this.changePhone || this.changeName;
    }
}

Object.assign(CustomerUserChange.prototype, ValidationMixin);

export default CustomerUserChange;



// WEBPACK FOOTER //
// ./src/records/customer/UserChange.js